
import { useQueryClient } from '@tanstack/react-query';

export const useCTraderInvalidation = () => {
  const queryClient = useQueryClient();
  
  const invalidateProfileQueries = async (id: string, refetchType: 'active' | 'all' = 'active') => {
    await Promise.all([
      queryClient.invalidateQueries({ 
        queryKey: ['ctraderAccounts'],
        refetchType
      }),
      queryClient.invalidateQueries({ 
        queryKey: ['ctraderProfile', id],
        refetchType
      }),
      queryClient.invalidateQueries({ 
        queryKey: ['apiConnections', id],
        refetchType
      }),
      queryClient.invalidateQueries({ 
        queryKey: ['tradingAccounts', id],
        refetchType 
      })
    ]);
  };

  const invalidateResourceUsage = () => {
    queryClient.invalidateQueries({ 
      queryKey: ['resourceUsage'],
      refetchType: 'active'
    });
  };

  return {
    invalidateProfileQueries,
    invalidateResourceUsage
  };
};
